import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, effect, inject, input, signal } from '@angular/core';
import { ContentLayout9, Section } from '@components/content/components/content-layout-9/model';
import { ResponsiveService } from '@services/responsive';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';
import { IconsDirective } from '@shared/directives';
import { MenuAnchor } from '@shared/models';

@Component({
  selector: 'app-content-layout-9',
  imports: [VideoComponent, VideoComponent, TitleComponent, NgTemplateOutlet, IconsDirective, ImageComponent],
  templateUrl: './content-layout-9.component.html',
  styleUrl: './content-layout-9.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout9Component {
  readonly data = input.required<ContentLayout9>();
  sections = signal<Section[]>(null!);
  menu = signal<MenuAnchor[]>([]);
  breakpoints = inject(ResponsiveService).breakpoints;
  readonly #document = inject<Document>(DOCUMENT);
  readonly window = this.#document.defaultView as Window;

  constructor() {
    effect(() => {
      if (this.breakpoints()) {
        this.menu.set([]);
        this.sections.set(
          this.data().sections.map((section, index) => {
            const anchor = `section_${index}`;
            section.anchor = anchor;
            if ('menuTitle' in section.data && section.data.menuTitle && section.data.menuTitle.length > 0) {
              this.menu.update((menu) => [...menu, { label: section.data.menuTitle ?? '', anchor }]);
            }
            if ('title' in section.data) {
              section.data.titleFormatted = {
                level: 'H2',
                weight: 600,
                size: {
                  desktop: 'H4',
                  mobile: 'H4',
                },
                color: 'BLACK',
                text: section.data.title ?? '',
              };
            }
            return section;
          })
        );
      }
    });
  }

  goToSection(anchor: string) {
    const element = this.#document.getElementById(anchor);
    if (element) {
      const rect = element.getBoundingClientRect();
      const offset = 72;
      const scrollOptions: ScrollToOptions = {
        left: rect.left + this.window.scrollX,
        top: rect.top + this.window.scrollY - offset,
        behavior: 'smooth',
      };
      this.window.scrollTo(scrollOptions);
    }
  }
}
